import { useOrchestratorApi } from '@/api/orchestrator'
import type { WidgetHostingMode, WidgetOptions } from '@/types'
import type { CustomCssVariables } from 'widget-components/types'
import type { Breakpoint } from 'widget-components/composables/breakpoints'

type UiOptionsResponse = {
    cssVariables: CustomCssVariables
    widgetOptions: Record<WidgetHostingMode, WidgetOptions>
    experimentalWidgetComponents?: boolean
    forcedBreakpoint?: Breakpoint
}

const getOptions = async () => {
    const client = useOrchestratorApi()

    const response = await client.request<Partial<UiOptionsResponse> | null>({
        method: 'get',
        url: `/workflows/ui-options`,
    })

    return response.data
}

export const useRemoteWidgetOptions = () => {
    return {
        getOptions,
    }
}
